import { getState, gainXP } from './coreGameLogic';

let projects = [];

export async function loadProjects(projectsDataPath) {
  try {
    const response = await fetch(projectsDataPath);
    if (!response.ok) throw new Error('Failed to load projects');
    projects = await response.json();
  } catch (error) {
    console.error('Project load error:', error);
    projects = [];
  }
}

export function getProjects() {
  return projects;
}

export function discoverProject(projectId, xpPerProject = 10) {
  const state = getState();
  if (!state.achievements.includes(projectId)) {
    state.achievements.push(projectId);
    gainXP(xpPerProject);
  }
}